import React from 'react'
import { Spinner } from 'reactstrap'
import PropTypes from 'prop-types'
import Icofont from 'react-icofont'

const Stepper = ({ children }) => {
  const steps = React.Children.toArray(children)

  return (
    <div className="stepper-horizontal">
      {steps.map((child, index) => {
        const isLast = index === steps.length - 1
        
        // Determine connector state based on child props
        let connectorClass = 'stepper-connector'
        if (child.props.success) {
          connectorClass += ' stepper-connector--done'
        } else if (child.props.active) {
          connectorClass += ' stepper-connector--active'
        }

        return (
          <React.Fragment key={index}>
            {React.cloneElement(child, {
              stepIndex: index + 1
            })}
            {!isLast && (
              <div className={connectorClass} />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

Stepper.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.element.isRequired
  ).isRequired
}

const Step = ({
  active = null,
  children,
  error = null,
  success = null,
  stepIndex = null
}) => {
  // Determine state classes
  const stateClasses = []
  if (active) stateClasses.push('stepper-step--active')
  if (error) stateClasses.push('stepper-step--error')
  if (success) stateClasses.push('stepper-step--success')
  if (!active && !error && !success) stateClasses.push('stepper-step--pending')

  // Determine circle content
  let circleContent
  if (active) {
    circleContent = <Spinner color="light" size="sm" />
  } else if (error) {
    circleContent = <Icofont icon="close" />
  } else if (success) {
    circleContent = <Icofont icon="check" />
  } else {
    circleContent = stepIndex
  }

  return (
    <div className={`stepper-step ${stateClasses.join(' ')}`}>
      <div className="stepper-circle">
        {circleContent}
      </div>
      <div className="stepper-label">
        {children}
      </div>
    </div>
  )
}

Step.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.string.isRequired,
  error: PropTypes.bool,
  success: PropTypes.bool,
  stepIndex: PropTypes.number
}

export { Step, Stepper }
